import React, { useState, useEffect } from "react";
import "./SponsorsContent.css";
import SponsorsLeaderData from "../data/SponsorsLeaderData.json";
import SponsorsCoreData from "../data/SponsorsCoreData.json";
import AOS from "aos";
import "aos/dist/aos.css";

function SponsorsContent() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="main-banner">
        <img
          src="/images/Sponsors/Sponsors-Banner.png"
          alt="banner"
          className="banner-img"
        />
      </div>
      <div className="sponsors-sec">
        <div className="sponsors-wrap" data-aos="zoom-in-up">
          <h2>Leadership</h2>
          <div className="leadership-wrap" style={{justifyContent: 'center', display: 'flex'}}>
            {SponsorsLeaderData.map((post) => {
              return (
                <div key={post.id} className="leadership-row">
                  <div className="leadership-box">
                    <img
                      src={post.leaderpic}
                      alt="sponsors"
                      className="sponsors-pic"
                    />
                    <h3>{post.leadername}</h3>
                    <p>{post.leadertext}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="core-team-sec">
        <div className="core-team-wrap" data-aos="zoom-in-up">
          <h2>Core Team</h2>
          <div style={{justifyContent: 'center', display: 'flex'}}>
          {SponsorsCoreData.map((post) => {
            return (
              <div key={post.id} className="core-team-row">
                <div className="core-team-box">
                  <img
                    src={post.leaderpic}
                    alt="sponsors"
                    className="sponsors-pic"
                  />
                  <h3>{post.leadername}</h3>
                  <p>{post.leadertext}</p>
                </div>
              </div>
            );
          })}
          </div>
        </div>
      </div>
    </>
  );
}

export default SponsorsContent;
